
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Home() {


  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">
      {/* Embedded YouTube Video Fullscreen */}
      <div className="absolute top-0 left-0 h-full w-full hidden sm:block z-0">
  <video
    autoPlay
    muted
    loop
    playsInline
    className="absolute top-0 left-0 h-full w-full object-cover"
  >
    <source src="./videos/construction.mp4" type="video/mp4" />
    Your browser does not support the video tag
  </video>
  <div className="absolute inset-0 bg-black/60" />
</div>

      {/* Fallback Image for Mobile */}
      <div className="absolute top-0 left-0 h-full w-full sm:hidden z-0">
        <img
          src="./images/hero-slider/slide3.jpg"
          alt="Construction site"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {/* Foreground Content */}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl font-extrabold sm:text-5xl md:text-6xl"
        >
          Engineering Excellence <br className="hidden sm:inline" />
          Driven by Innovation
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mt-6 max-w-2xl text-lg text-gray-200 sm:text-xl"
        >
          Matshinye Jr Holdings – Creating sustainable infrastructure for communities and growth.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="mt-8 flex gap-4 flex-wrap justify-center"
        >
          <a
            href="#services"
            className="rounded-full bg-accent px-8 py-3 text-base font-semibold text-primary shadow-lg transition hover:bg-accent-light"
          >
            Discover Our Services
          </a>
        </motion.div>
      </div>
    </section>
  );
}
